/**
 * Persist which active-document IDs the user dismissed from the "AI Context" bar,
 * scoped per conversation (or `home` when no streaming conversation id yet).
 */

const STORAGE_KEY = 'flownotes_dismissed_ai_context_v1'

export function convKeyForDismissals(conversationId: string | null | undefined): string {
  return conversationId ?? 'home'
}

function readAll(): Record<string, string[]> {
  if (typeof sessionStorage === 'undefined') return {}
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const o = JSON.parse(raw) as unknown
    return typeof o === 'object' && o !== null && !Array.isArray(o) ? (o as Record<string, string[]>) : {}
  } catch {
    return {}
  }
}

function writeAll(data: Record<string, string[]>) {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch {
    // quota / private mode
  }
}

export function loadDismissedDocIds(conversationId: string | null | undefined): Set<string> {
  const key = convKeyForDismissals(conversationId)
  const arr = readAll()[key] ?? []
  return new Set(arr.filter((id) => typeof id === 'string' && id.length > 0))
}

export function persistDismissedDocIds(
  conversationId: string | null | undefined,
  ids: Set<string>
) {
  const key = convKeyForDismissals(conversationId)
  const all = readAll()
  if (ids.size === 0) {
    delete all[key]
  } else {
    all[key] = Array.from(ids)
  }
  writeAll(all)
}

export function clearDismissedDocIdsForConversation(conversationId: string | null | undefined) {
  const key = convKeyForDismissals(conversationId)
  const all = readAll()
  delete all[key]
  writeAll(all)
}
